/**
 * Non Post Order Details
 */

// React
import React, {useState, useEffect, useContext} from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../redux/reducers';
import {
  getOrderWithIdAction,
  updateOrderStatusActions,
} from '../orders/actions';
import Client from 'client-sdk/src/client';
import {UpdateOrderDeliveryCost} from 'client-sdk/src/orders/orders';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
} from '../orders/selectors';

//UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  IconButton,
  TextField,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiCalendar,
  mdiStateMachine,
  mdiAccountOutline,
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiWarehouse,
  mdiKeyOutline,
  mdiCityVariantOutline,
  mdiSendCircleOutline,
  mdiWeight,
  mdiRuler,
  mdiCounter,
  mdiKey,
  mdiPaperRollOutline,
  mdiPackageVariant,
  mdiCurrencyUsd,
  mdiRefresh,
} from '@mdi/js';

// Components
import Can from '../../components/Can';
import List from './list';

// Helper
import {
  translateOrderStatus,
  formaterPhoneNumber,
  translateSendDeliveryType,
  translateOrderTransportationType,
  packegeCounter,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import handleNotfication from '../../utils/handleNotfication';

// Type
import {Status} from '../orders/interfaces';
import {SelectorProps, Props} from '../orderDetails/interfaces';
import {Link} from 'react-router-dom';
import {mdiText} from '@mdi/js/commonjs/mdi';
import orderRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import AlopeykRequest from '../orders/components/alopeykRequest';
import Modal from '../../components/Modal';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    retryIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.gray.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    retryTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function NonPostOrderDetails(props: Props) {
  const authContext = useContext(AuthContext);
  const token = localStorage.getItem('token') || '';
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openDeleteItem, setOpenDeleteItem] = React.useState(false);
  const [openRetryItem, setOpenRetryItem] = React.useState(false);
  const [error, setError] = useState('');
  const [request3PLError, setRequest3PLError] = useState('');
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const [order3PLs, setOrder3PLs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [request3PLLoading, setRequest3PLLoading] = useState(false);
  const [item, setItem] = useState({} as any);
  const [description, setDescription] = useState('');
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [orderDeliveryCost, setOrderDeliveryCost] = useState<null | number>(
    null
  );
  const classes = useStyles();

  useEffect(() => {
    getOrder();
    getOrder3PLs();
  }, []);

  useEffect(() => {
    if (props.order?.deliveryCost) {
      setOrderDeliveryCost(props.order?.deliveryCost);
    }
  }, [props.order]);

  const getOrder = () => {
    const {id} = props.match.params;
    props.orderWithIdActionDispatch(id);
  };

  const getOrder3PLs = () => {
    const {id} = props.match.params;
    const filters = {orderId: {equals: id}, unpaged: true};
    get3PLs({...filters});
  };

  const get3PLs = async (actions: any) => {
    const payload = {...actions};
    try {
      setRequest3PLLoading(true);
      const {response, callback} = await ordersRepository.getOrder3PLs({
        payload,
      });
      setOrder3PLs(response.data);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const handleChangeDeliveryCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderDeliveryCost(e.target?.value!);
  };
  const changeStatusOrder = () => {
    const {id} = props.match.params;
    props.updateOrderStatusDispatch({
      id: props.order.id,
      body: previewState.replace(/"/g, ''),
      pagination: {},
      callback: () => props.orderWithIdActionDispatch(id),
    });
    handleClose();
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const cancelItem = (item: any) => {
    setItem(item);
    setOpenDeleteItem(true);
  };
  const retrylItem = (item: any) => {
    setItem(item);
    setOpenRetryItem(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteItem(false);
  };
  const handleCloseRetryDialog = () => {
    setOpenRetryItem(false);
  };

  const cancelOrder3PL = async () => {
    const payload = {
      id: item.id,
      body: {description: description},
      callback: () => {
        getOrder();
        getOrder3PLs();
        setOpenDeleteItem(false);
      },
    };
    try {
      setLoading(true);
      const {callback} = await orderRepository.cancel3PLItems({
        payload,
      });
      handleNotfication('آیتم مورد نظر با موفقیت لغو شد ', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const retryOrder3PL = async () => {
    const payload = {
      id: item.id,
      callback: () => {
        getOrder();
        getOrder3PLs();
        setOpenRetryItem(false);
      },
    };
    try {
      setLoading(true);
      const {response, callback} = await orderRepository.sendRequestOrder3PL({
        payload,
      });
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };
  const submitOrderDeliveryCost = async () => {
    try {
      const {id} = props.match.params;
      const makeRequest = new UpdateOrderDeliveryCost()
        .id(id)
        .data(orderDeliveryCost)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('کد پیگیری پست با موفقیت ثبت شد', 'success');
      props.orderWithIdActionDispatch(id);
    } catch (err) {
      handleNotfication(
        'تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید',
        'error'
      );
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{props.order.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
        <Can
          perform="orderDetail:print"
          role={authContext.user.role}
          yes={() => (
            <Link
              to={`/orders/receipts/${props.order.id}`}
              target="_blank"
              style={{textDecoration: 'none'}}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                authContext.user.role === 'WAREHOUSE_ADMIN'
                  ? 'چاپ رسید'
                  : 'چاپ حواله'}
              </Button>
            </Link>
          )}
        />
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام شرکت:  '}
              </span>

              <span>{props.order?.partnerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {'مبدا(انبار/مرکز):  '}
              </span>

              <span>
                {props.order?.fulfillmentWarehouseName
                  ? props.order?.fulfillmentWarehouseName
                  : props.order?.centerName}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKey} size={1} className={classes.icon} />
                {'کد پیگیری:  '}
              </span>

              <span>{props.order?.trackingCode}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {'تعداد بسته:  '}
              </span>
              <span>
                {props.order?.orderPackages &&
                  packegeCounter(props.order?.orderPackages)}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام سفارش‌دهنده:  '}
              </span>

              <span>{props.order.customerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شماره همراه سفارش‌دهنده:  '}
              </span>
              <span>
                {formaterPhoneNumber(props.order.customerMobileNumber)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiKeyOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شماره ملی سفارش‌دهنده:  '}
              </span>
              <span>
                {formaterPhoneNumber(props.order.customerNationalCode)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {'تاریخ تحویل سفارش:  '}
              </span>
              <span>
                {props.order.deliveryDate &&
                  `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}`}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {'ساعت تحویل سفارش:  '}
              </span>
              <span>
                {`${jMoment(props.order.deliveryStartTime, 'HH:mm:ss')
                  .locale('fa')
                  .format('HH:mm')}`}
                {` - ${jMoment(props.order.deliveryEndTime, 'HH:mm:ss')
                  .locale('fa')
                  .format('HH:mm')}`}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'کد پستی:  '}
              </span>
              <span>{formaterPhoneNumber(props.order.customerZipCode)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'استان:  '}
              </span>
              <span>{formaterPhoneNumber(props.order.customerProvince)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCityVariantOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'شهر:  '}
              </span>
              <span>{formaterPhoneNumber(props.order.customerCity)}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {'آدرس سفارش‌دهنده:  '}
              </span>
              <span>
                {props.order.customerAddress && props.order.customerAddress}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPaperRollOutline}
                  size={1}
                  className={classes.icon}
                />
                {'توضیحات:  '}
              </span>
              <span>{props.order.description && props.order.description}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiSendCircleOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {'نوع ارسال:  '}
              </span>
              <span>
                {translateSendDeliveryType(props.order?.deliveryType)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {'تعداد آیتم های سفارش:  '}
              </span>
              <span>{props.order?.items?.length}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWeight} size={1} className={classes.rtlIcon} />
                {'وزن سفارش:  '}
              </span>
              <span>{props.order.weight}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiRuler} size={1} className={classes.rtlIcon} />
                {'ابعاد سفارش:  '}
              </span>
              <span dir="ltr">
                {props.order.length
                  ? `${props.order.length} x ${props.order.width} x ${props.order.height}`
                  : '-'}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCurrencyUsd} size={1} />
                {'هزینه ارسال(ریال):'}
              </span>
              <Can
                role={authContext.user.role}
                perform="orders:post-tracking-code"
                yes={() => (
                  <React.Fragment>
                    <TextField
                      id="outlined-basic"
                      value={orderDeliveryCost}
                      onChange={handleChangeDeliveryCost}
                      size={'small'}
                      variant="outlined"
                    />
                    <Button
                      style={{marginRight: '5px'}}
                      variant="contained"
                      color="secondary"
                      onClick={submitOrderDeliveryCost}
                      size={'medium'}
                    >{`ثبت`}</Button>
                  </React.Fragment>
                )}
                no={() => <span>{props.order?.deliveryCost}</span>}
              />
            </div>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid
          style={{margin: 0}}
          container
          spacing={1}
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <h3 style={{marginTop: 0}}>{'اطلاعات پیک'}</h3>
          </Grid>
          {props.order.orderTPLType === 'ALOPEYK' && (
            <Grid item>
              <Button
                onClick={() => setOpenAlopeykRequest(true)}
                variant="contained"
              >
                {'جزئیات بیشتر'}
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid
          style={{margin: 0}}
          container
          spacing={1}
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <img
              style={{width: '60px', objectFit: 'contain'}}
              src={
                props.order.orderTPLType === 'ALOPEYK'
                  ? '/alopeyk.png'
                  : props.order.orderTPLType === 'TAROFF'
                  ? '/taarof.png'
                  : props.order.orderTPLType === 'LINK_EXPRESS'
                  ? '/link-express.png'
                  : props.order.orderTPLType === 'CHAPAR'
                  ? '/chapar.png'
                  : ''
              }
              alt={props.order.tpl}
            />
          </Grid>
          <Grid item>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {'تاریخ ثبت در 3PL:  '}
              </span>
              <span>
                {props.order.submitToTPLDate &&
                  `${jMoment(props.order.submitToTPLDate, 'YYYY/MM/DD HH:mm:ss')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD HH:mm:ss')}`}
              </span>
            </div>
          </Grid>
        </Grid>
        <Grid>
          {order3PLs && (
            <List
              data={order3PLs}
              cancelItem={cancelItem}
              retrylItem={retrylItem}
            />
          )}
        </Grid>
      </Paper>

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translateOrderStatus(props.order.status)}"
        به
       " ${translateOrderStatus(previewState.replace(/"/g, '') as Status)}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={() => setOpenAlopeykRequest(false)}
        open={openAlopeykRequest}
        title={
          <div>
            <h3
              style={{display: 'flex', marginBottom: 0, alignItems: 'center'}}
            >
              {`ارسال درخواست سفارش 
                   ${props.match.params.id} 
                    به `}
              <strong>
                {translateOrderTransportationType(props.order.orderTPLType)}
              </strong>
              <img
                style={{width: '60px', objectFit: 'contain', margin: '0 20px'}}
                src={'/alopeyk.png'}
                alt={'alopeyk'}
              />
            </h3>
          </div>
        }
        content={
          <AlopeykRequest
            orderId={props.match.params.id}
            id={order3PLs[order3PLs.length - 1]?.id}
          />
        }
      />

      <Dialog open={openDeleteItem} onClose={handleCloseDialog}>
        <DialogContent style={{width: '600px'}}>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialog ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialog}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <p>
            آیا از لغو آیتم 3PL با شناسه
            <strong> {item.id} </strong> مطمئن هستید
          </p>
          <Grid container item xs={12} alignItems="flex-end">
            <div className={classes.item} style={{width: '100%'}}>
              <span className={classes.label}>
                <Icon path={mdiText} size={1} className={classes.icon} />
              </span>

              <span style={{width: '100%'}}>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                  className={classes.textInput}
                />
              </span>
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={cancelOrder3PL}
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
                disabled={loading || !description}
              >
                {`بله`}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseDialog}
                variant="contained"
                fullWidth
                autoFocus
              >
                {`خیر`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog open={openRetryItem} onClose={handleCloseRetryDialog}>
        <DialogContent style={{width: '600px'}}>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseRetryDialog ? (
              <IconButton aria-label="retry" onClick={handleCloseRetryDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.retryIcon}>
            <Icon path={mdiRefresh} size={4} color={theme.palette.gray.main} />
          </div>
          <div className={classes.retryTitle}>از ارسال سفارش مطمئن هستید</div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={retryOrder3PL}
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
              >
                {`بله`}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseRetryDialog}
                variant="contained"
                fullWidth
                autoFocus
              >
                {`خیر`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  order: makeSelectOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({id})),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(NonPostOrderDetails);
